import PropTypes from 'prop-types'

import { removeLogicFromText } from '@aytm/app/stats/page/components/lib/utils'

import style from '@aytm/app/stats/page/comments/styles/index.module.scss'

// The responses pages show no aytm logic: like the comments page's question titles, the video
// question's title and instructions drop their markers, piping and @aliases whatever the setting.
const VideoQuestion = ({ question }) => (
  <div className={style['video-question']}>
    <div className={style['video-question-title']}>
      <strong>Q{question.visual_position}: </strong>
      <span dangerouslySetInnerHTML={{ __html: removeLogicFromText(question.text || '') }} />
    </div>
    <div
      className={style['video-question-instruction']}
      dangerouslySetInnerHTML={{ __html: removeLogicFromText(question.va_instructions || '') }}
    />
  </div>
)

VideoQuestion.propTypes = {
  question: PropTypes.shape({
    visual_position: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    text: PropTypes.string,
    va_instructions: PropTypes.string
  }).isRequired
}

export default VideoQuestion
